import { lazy } from 'react'
import {
	Route, RouterProvider,
	createBrowserRouter,
	createRoutesFromElements
} from 'react-router-dom'
import * as constants from 'resources/constants'
import { Role } from 'resources/types'
import LoginPage from 'views/login'
import LayoutWithSidebar from './LayoutWithSidebar'
import ProtectedRoute from './ProtectedRoute'
import RouteWrapper from './RouteWrapper'

const ProjectsPage = lazy(() => import('views/projects'))
const CreateAccountPage = lazy(() => import('views/createAccount'))
const CreateCompanyPage = lazy(() => import('views/createCompany'))
const AccountActivation = lazy(() => import('views/accountActivation'))
const ManageUsers = lazy(() => import('views/users/manageUsers'))
const TagsPage = lazy(() => import('views/tags'))
const ProjectPage = lazy(() => import('views/project'))
const AnalyticsPage = lazy(() => import('views/analytics'))
const MyDashboardPage = lazy(() => import('views/myDashboard'))
const ProfilePage = lazy(() => import('views/profile'))
const ResetPasswordPage = lazy(() => import('views/resetPassword'))
const NotificationsPage = lazy(() => import('views/notifications'))
const CampaignsPage = lazy(() => import('views/Campaigns'))
const AdminSettingsPage = lazy(() => import('views/adminSettings'))
const ReportsPage = lazy(() => import('views/reports'))
const CompleteProfilePage = lazy(() => import('views/completeProfile'))
const NotFound404Page = lazy(() => import('views/404NotFound'))
const NotAuthorized403Page = lazy(() => import('views/403NotAuthorized'))
const TimelinePage = lazy(() => import('views/timeline'))
const DownloadPage = lazy(() => import('views/download'))

// const TestPage = lazy(() => import('views/testPage'))

const router = createBrowserRouter(createRoutesFromElements([
	<Route path='/' element={<RouteWrapper />}>
		<Route index element={<LoginPage />} />
		<Route path={constants.loginPage} element={<LoginPage />} />
		<Route path={constants.createAccountPage} element={<CreateAccountPage />} />
		<Route path={constants.createCompanyPage} element={<CreateCompanyPage />} />
		<Route path={constants.accountActivation} element={<AccountActivation />} />
		<Route path={constants.resetPasswordURL} element={<ResetPasswordPage />} />

		{/* Public Timeline Routes */}
		<Route path={constants.timelinePage} element={<TimelinePage />} />
		<Route path={constants.downloadPage} element={<DownloadPage />} />

		<Route element={<ProtectedRoute />}>
			<Route path={constants.completeProfileURL} element={<CompleteProfilePage />} />

			<Route element={<LayoutWithSidebar />}>
				{/* Common Routes */}
				<Route path={constants.profilePage} element={<ProfilePage />} />
				<Route path={constants.notificationsURL} element={<NotificationsPage />} />
				<Route path={constants.notificationURL} element={<NotificationsPage />} />

				{/* Admin Routes */}
				<Route element={<ProtectedRoute userRole={[Role.ADMIN, Role.ACCOUNT_OWNER, Role.EMPLOYEE]} />}>
					<Route path={constants.manageUsersPage} element={<ManageUsers />} />
					<Route path={constants.notificationCampaignsURL} element={<CampaignsPage />} />
					{/* <Route path={constants.autoNotificationsURL} element={<AutoNotificationPage />} /> */}
					<Route path={constants.adminSettingsURL} element={<AdminSettingsPage />} />
					<Route path={constants.projectsURL} element={<ProjectsPage />} />
					<Route path={constants.projectDetailURL} element={<ProjectPage />} />
					<Route path={constants.tagsURL} element={<TagsPage />} />
					<Route path={constants.analyticsPageURL} element={<AnalyticsPage />} />

					<Route element={<ProtectedRoute userRole={[Role.EMPLOYEE]} />}>
						<Route path={constants.myDashboardURL} element={<MyDashboardPage />} />
					</Route>

				</Route>

				<Route element={<ProtectedRoute userRole={[Role.ADMIN, Role.ACCOUNT_OWNER]} />}>
					<Route path={constants.ReportsPageURL} element={<ReportsPage />} />
				</Route>
			</Route>
		</Route>

		<Route path={constants.notAuthorized} element={<NotAuthorized403Page />} />
		 {/* 🧭 Catch-all 404 route */}
		<Route path='*' element={<NotFound404Page />} />
	</Route>,
]))

const Routes = () => <RouterProvider router={router} />
export default Routes
